import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogram/sipchannel/";

export default class SIPChannelApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getSIPChannels(params) {
    return await request.post(`${rootRoute}getSIPChannels`, {
      filter: params,
      parameters: {},
    });
  }
  async getSIPChannel(id) {
    return await request.post(`${rootRoute}getSIPChannels`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createSIPChannel(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createSIPChannel`, { data });
  }
  async deleteSIPChannel(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteSIPChannel`, { data });
  }
  async editSIPChannel(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateSIPChannel`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importSIPChannel`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getSIPChannelimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportSIPChannel`, {
      filter: filter,
      format: format
    });
  }
}
